<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
        <defs>
            <clipPath id="clip-Arrow_menu_déroulant_nav_">
                <rect width="50" height="50" />
            </clipPath>
        </defs>
        <g id="Arrow_menu_déroulant_nav_" data-name="Arrow menu déroulant nav " clip-path="url(#clip-Arrow_menu_déroulant_nav_)">
            <g id="noun_Arrow_2052618" transform="translate(-98 655.18)">
                <g id="Groupe_2636" data-name="Groupe 2636" transform="translate(116.659 -635.191)">
                    <path
                        id="Tracé_2690"
                        data-name="Tracé 2690"
                        d="M11.635.067c.673-.168,1.536.757,1.094,1.473L7.238,10.418a.985.985,0,0,1-1.368,0L.378,1.539C-.063.824.8-.1,1.473.067Z"
                        transform="translate(-0.258 -0.047)"
                        :fill="color"
                        fill-rule="evenodd"
                    />
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconDropdown',
    mixins: [Colorable],
};
</script>
